import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../config/authAxios"


const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const getUserCityAction = createAsyncThunk(
    'get-user-city',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/pwa/api/get-city`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getUserCitySlice = createSlice({
    name: 'get-user-city',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getUserCityAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(getUserCityAction.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(getUserCityAction.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const getUserCityReducer = getUserCitySlice.reducer